var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function loadCreativeForLanguage(id, size, language, resolvePath) {
    return Promise.any(['png', 'gif', 'jpg'].map((fileSuffix) => __awaiter(this, void 0, void 0, function* () {
        const creative = (yield resolvePath(`${size}/${id}${size}_${language}.${fileSuffix}`)).default;
        if (creative) {
            return creative;
        }
        throw Error('Not found');
    })));
}
export function loadLocalCreative(id, size, language, defaultLanguage, resolvePath) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            return yield loadCreativeForLanguage(id, size, language, resolvePath);
        }
        catch (e) {
            try {
                return yield loadCreativeForLanguage(id, size, defaultLanguage, resolvePath);
            }
            catch (e) {
                return null;
            }
        }
    });
}
//# sourceMappingURL=CreativeUtils.js.map